import { useStore } from '@/store'

const store = useStore()

export default function useFlashMessage () {
  return function (notificationData) {
    return store.dispatch('ApplicationStore/showNotfication', notificationData)
  }
}
